var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.projects.length > 0)?_c('div',{staticClass:"grid grid-cols-1 col-gap-6 row-gap-8"},_vm._l((_vm.projects),function(project){return _c('project-card',{key:project.id,attrs:{"project":project}})}),1):_c('div',{staticClass:"text-gray-600 font-hairline"},[_vm._v("\n        No posted job found for this employer.\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }